// Shared curated lucide icon set for the First-Visit Onboarding steps.
// Used by both the Admin step manager (icon picker) and the storefront popup,
// so the two always stay in sync.
import {
  BookOpen, FlaskConical, Droplets, Ruler, Package, ShoppingBag, Layers,
  Sparkles, Wand2, Gem, Flame, Crown, Gift, Heart, Star, Leaf, Feather,
  Beaker, Palette, Clock, Award, Atom, Sun, Moon,
} from "lucide-react";

export const STEP_ICONS = {
  "book-open": BookOpen,
  "flask-conical": FlaskConical,
  droplets: Droplets,
  ruler: Ruler,
  package: Package,
  "shopping-bag": ShoppingBag,
  layers: Layers,
  sparkles: Sparkles,
  wand: Wand2,
  gem: Gem,
  flame: Flame,
  crown: Crown,
  gift: Gift,
  heart: Heart,
  star: Star,
  leaf: Leaf,
  feather: Feather,
  beaker: Beaker,
  palette: Palette,
  clock: Clock,
  award: Award,
  atom: Atom,
  sun: Sun,
  moon: Moon,
};

export const STEP_ICON_NAMES = Object.keys(STEP_ICONS);

export const resolveStepIcon = (name) => STEP_ICONS[(name || "").toLowerCase()] || Sparkles;
